import React from 'react';
import i18next from 'i18next';
import { DateFormatter, TextCell } from 'components/AppTable/CellsComponents';

const getTableConfig = () => {
  return [
    {
      title: i18next.t('tablesLabels.id'),
      field: 'userId',
      isVisible: false,
    },
    {
      title: i18next.t('tablesLabels.name'),
      field: 'fullName',
      Component: value => <TextCell value={value} />,
      isSorting: true,
    },
    {
      title: i18next.t('tablesLabels.jobTask'),
      field: 'jobTask',
      Component: value => <TextCell value={value} />,
      isSorting: true,
    },
    {
      title: i18next.t('complianceStatus'),
      field: 'complianceStatus',
      Component: value => (
        <TextCell
          value={
            value
              ? i18next.t(`compliance.statuses.${value}`, { defaultValue: value })
              : i18next.t('compliance.statuses.incomplete')
          }
        />
      ),
      isSorting: true,
    },
    {
      title: i18next.t('tablesLabels.expiryDate'),
      field: 'expirationDate',
      Component: value => (value ? <DateFormatter value={value} /> : i18next.t('compliance.statuses.incomplete')),
      isSorting: true,
    },
  ];
};

export default getTableConfig;
